import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { revealUp, staggerParent, viewportOnce } from "../../lib/motion";
import { STORY_TEXTURES } from "../../data/site";

export const StoryCTA = () => {
  return (
    <section data-testid="story-cta" className="py-4 pb-10 sm:py-6 sm:pb-16">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="grid w-full overflow-hidden rounded-[28px] bg-labred md:grid-cols-2">
          {/* Image */}
          <div className="relative min-h-[280px] overflow-hidden md:min-h-[520px]">
            <motion.img
              src={STORY_TEXTURES.cta}
              alt="Chicken Labb crispy tenders"
              initial={{ scale: 1.12 }}
              whileInView={{ scale: 1 }}
              viewport={viewportOnce}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>

          {/* Copy */}
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            variants={staggerParent}
            className="flex flex-col justify-center px-7 py-14 sm:px-12 sm:py-16 lg:px-16"
          >
            <motion.p variants={revealUp} className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
              05 / TASTE THE RESULT
            </motion.p>
            <motion.h2 variants={revealUp} className="font-display text-3xl leading-[1.05] tracking-tight text-paper sm:text-5xl">
              THE RESULTS ARE ON THE MENU.
            </motion.h2>

            <motion.div variants={revealUp} className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                to="/menu"
                data-testid="story-cta-menu"
                className="inline-flex items-center justify-center rounded-full bg-paper px-8 py-3.5 font-display text-xs uppercase tracking-wider text-inkred transition-colors duration-150 hover:bg-labyellow"
              >
                See the Menu
              </Link>
              <Link
                to="/contact"
                data-testid="story-cta-find"
                className="inline-flex items-center justify-center rounded-full border border-paper/60 bg-transparent px-8 py-3.5 font-display text-xs uppercase tracking-wider text-paper transition-colors duration-150 hover:border-labyellow hover:text-labyellow"
              >
                Find Us
              </Link>
            </motion.div>

            <motion.p variants={revealUp} className="mt-10 font-mono text-[11px] uppercase leading-relaxed tracking-[0.25em] text-paper/70">
              1216 MAIN AVE&nbsp;&nbsp;//&nbsp;&nbsp;908 333 6363&nbsp;&nbsp;//&nbsp;&nbsp;@CHICKENLABB_OFFICIAL
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
